module.exports = __webpack_public_path__ + "img/mhtit4.4d16a704.png";